<template>
  <div>
    <div>Дата:</div>
    <el-date-picker
      value-format="yyyy-MM-dd"
      format="dd.MM.yyyy"
      v-model="choosenDay"
      :picker-options="datePickerOptions"
      placeholder="Выбрать день">
    </el-date-picker>
    <b-table
      class="mt-3"
      :items="stats"
      :fields="columns.concat(columnsInner)">
      <template slot="HEAD[idWorker]" slot-scope="data">
        {{data.label}}
      </template>
      <template slot="HEAD[total]" slot-scope="data">
        {{'Оборот (итого): ' + data.field.maxTurnover}}<hr>
        {{data.label}}
      </template>
      <template slot="HEAD[sumProbablyEarning]" slot-scope="data">
        {{data.label}}
      </template>
      <template slot="HEAD[]" slot-scope="data">
        {{data.label}}<hr>
        {{'Оборот: ' + data.field.maxTurnover}}<hr>
        {{parseInt(data.field.maxPercent) + '%'}}
      </template>
      <template slot="[]" slot-scope="data">
        {{(data.value instanceof Object) ? (data.value.reward ? parseFloat(data.value.reward).toFixed(0) : '-') : data.value}}
      </template>

<!--      <template slot="stats" slot-scope="data">-->
<!--        <b-table-->
<!--          :items="data.value"-->
<!--          :fields="columnsInner"-->
<!--        >-->
<!--          <template slot="[]" slot-scope="data">-->
<!--            {{data.value}}<br>-->
<!--            {{data.value.reward ? parseFloat(data.value.reward).toFixed(0) : '-'}}-->
<!--          </template>-->
<!--        </b-table>-->
<!--      </template>-->
    </b-table>
  </div>
</template>

<script>
import {overallWorkshopStatsGetters as getters} from '../constants/vuexGetters'
import {overallWorkshopStatsAct as actions} from '../constants/vuexActions'
import {overallWorkshopStatsVars as vars} from '../constants/vuexVariables'

export default {
  name: 'StatsWorkshopScreen',
  data () {
    return {
      intervalUpdateWorkerList: null,
      vuexNamespace: 'overallWorkshopStat',
      columns: [
        {
          label: 'Сотрудник',
          key: 'idWorker'
        }
      ],
      datePickerOptions: {
        firstDayOfWeek: 1,
        disabledDate (date) {
          let newDate = new Date()
          newDate.setDate(newDate.getDate())
          return date > newDate
        }
      }
      // {
      //   label: 'Статистика',
      //   key: 'stats'
      // }
    }
  },
  computed: {
    stats () {
      return this.getter(getters.TABLE_STATS)
    },
    columnsInner () {
      return this.getter(getters.TABLE_COLUMNS)
    },
    choosenDay: {
      get () {
        return this.stateVar(vars.requestedDay)
      },
      set (value) {
        this.dispatch(actions.CHANGE_CURRENT_DATE, value)
      }
    }
  },
  created () {
    this.dispatch(actions.REQUEST_WORKER_LIST)
    this.intervalUpdateWorkerList = setInterval(
      () => {
        this.dispatch(actions.REQUEST_WORKER_LIST)
      },
      60000
    )
  },
  beforeDestroy () {
    clearInterval(this.intervalUpdateWorkerList)
  },
  methods: {
    getter (getter) {
      return this.$store.getters[`${this.vuexNamespace}/${getter}`]
    },
    dispatch (action, payload) {
      this.$store.dispatch(`${this.vuexNamespace}/${action}`, payload)
    },
    stateVar (variable) {
      return this.$store.state.overallWorkshopStat[variable]
    },
    commit (query, payload) {
      this.$store.commit(`${this.vuexNamespace}/${query}`, payload)
    }
  }
}
</script>

<style scoped>
  .hidden-header {
    display:none;
  }
</style>



// WEBPACK FOOTER //
// src/components/StatsWorkshopScreen.vue